import PropTypes from "prop-types"
import React from "react"
import { useTranslation } from "react-i18next"

export const TextAreaBox = ({
    id,
    className,
    name,
    value,
    type,
    label,
    onChangeHandler,
    disabled,
    isRequired,
    errors,
    maxLength,
    minLength,
    pattern,
    row,
    dataTestId,
    customErrorObjName,
    wrapperClass,
    defaultValue,
    isComponentLabelValidation = true //  DONT' MODIFY THIS FLAG, PASS VALUE FROM COMPONENT LABEL
}) => {
    const isValid = errors && name && errors[name] ? false : true
    const CLASS_NAME =
    className ||
    "w-full p-3 text-sm text-gray-900 rounded-lg" +
      " border border-lightGray appearance-none focus:outline-none" +
      " focus:ring-0 focus:border-primary-100 peer"
    const INPUT_CLASS = isValid
        ? `block disabled:bg-lighestgray  focus:outline-none 
        focus:ring-0 focus:border-primary-100 focus:bg-lightSkyblue 
        hover:border-primary-100 transition duration-300 ${CLASS_NAME}`
        : `block disabled:bg-lighestgray border-red 
        focus:outline-none focus:ring-0 focus:border-primary-100 
        focus:bg-lightSkyblue hover:border-primary-100 transition duration-300 ${CLASS_NAME}`
    const { t } = useTranslation()
    return (
        <>
          
            <div className={ `${wrapperClass} relative` }>
                <textarea
                    type={ type }
                    id={ id }
                    data-testid={ dataTestId }
                    pattern={ pattern }
                    maxLength={ maxLength || "" }
                    minLength={ minLength || "" }
                    className={ INPUT_CLASS }
                    defaultValue={ defaultValue }
                    placeholder=""
                    name={ name }
                    value={ value }
                    rows={ row }
                    disabled={ disabled }
                    onChange={ onChangeHandler ? onChangeHandler : "" }                           
                />
                <label
                    htmlFor={ id }
                    className="absolute flex text-sm text-placeHolderColor duration-300 
                    transform -translate-y-[28px] scale-75 top-16 origin-[0] bg-white 
                    dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 
                    peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 
                    peer-placeholder-shown:top-[28px] peer-focus:top-16 peer-focus:scale-75 
                    peer-focus:-translate-y-[28px] rtl:peer-focus:translate-x-1/2 
                    rtl:peer-focus:left-auto start-17 cursor-text font-['Avenir'] font-normal"
                >
                    { isRequired && (
                        <span className="text-red text-sm mr-1 flex">*</span>
                    ) }
                    { label || name }
                </label>
            </div>
          
            { isComponentLabelValidation && errors && name && errors[name] && (
                <span className="text-red text-xs font-normal font-['Avenir'] leading-[14px]">
                    { customErrorObjName
                        ? t(`errorMessage.${customErrorObjName}.${name}`)
                        : t(`errorMessage.${name}`) }
                </span>
            ) }
           
             
        </>
    )
}

TextAreaBox.propTypes = {
    className: PropTypes.string,
    disabled: PropTypes.bool,
    errors: PropTypes.object,
    id: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    maxLength: PropTypes.string,
    name: PropTypes.string.isRequired,
    onChangeHandler: PropTypes.func,
    pattern: PropTypes.string,
    type: PropTypes.string.isRequired,
    value: PropTypes.string
}
